import { render, staticRenderFns } from "./Asistance.vue?vue&type=template&id=0c0935f8&scoped=true"
import script from "./Asistance.vue?vue&type=script&lang=js"
export * from "./Asistance.vue?vue&type=script&lang=js"
import style0 from "./Asistance.vue?vue&type=style&index=0&id=0c0935f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0935f8",
  null
  
)

export default component.exports